import { getItem, setItem, removeItem } from 'owa-local-storage';

const APPLICATION_SETTING_OVERRIDES_LOCAL_STORAGE_KEY = 'applicationSettingOverrides';

export const getLocalOverrides = () => {
    const localOverrides = getItem(self, APPLICATION_SETTING_OVERRIDES_LOCAL_STORAGE_KEY);

    if (localOverrides) {
        try {
            return JSON.parse(localOverrides);
        } catch (e) {
            return {};
        }
    }

    return {};
};

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7006 (22,34): Parameter 'setting' implicitly has an 'any' type.
// @ts-expect-error
export const setLocalOverride = (setting, value) => {
    const localOverrides = getLocalOverrides();

    localOverrides[setting] = value;

    setItem(
        window,
        APPLICATION_SETTING_OVERRIDES_LOCAL_STORAGE_KEY,
        JSON.stringify(localOverrides)
    );
};

export const resetLocalOverrides = () => {
    removeItem(window, APPLICATION_SETTING_OVERRIDES_LOCAL_STORAGE_KEY);
};
